// // import React, { useState, useEffect } from 'react';
// // import { useNavigate } from 'react-router-dom'; // Navigation ke liye
// // import { 
// //   Box, Grid, Paper, Typography, alpha, CircularProgress 
// // } from '@mui/material';
// // import { 
// //   Newspaper, PlaySquare, TrendingUp, TrendingDown, 
// //   Users, Building2, BarChart3, Heading 
// // } from 'lucide-react';
// // import { 
// //   XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, AreaChart, Area 
// // } from 'recharts';

// // // API Service (Import your function)
// // import { getDashboardStats } from '../../../services/adminService'; 

// // // Stat Card Component - Isme onClick add kiya hai
// // const StatCard = ({ title, value, trend, trendValue, icon: Icon, color, onClick }) => (
// //   <Paper 
// //     elevation={0} 
// //     onClick={onClick} // Click handler yahan lagaya
// //     sx={{
// //       p: 4,
// //       height: '100%',
// //       borderRadius: '24px',
// //       border: '1px solid',
// //       borderColor: alpha('#e2e8f0', 0.8),
// //       background: '#ffffff',
// //       position: 'relative',
// //       overflow: 'hidden',
// //       display: 'flex',
// //       flexDirection: 'column',
// //       justifyContent: 'center',
// //       cursor: 'pointer', // Pointer cursor taaki pata chale click hoga
// //       transition: 'all 0.3s ease',
// //       '&:hover': {
// //         transform: 'translateY(-5px)',
// //         boxShadow: '0 20px 25px -5px rgba(0,0,0,0.05)',
// //         borderColor: alpha(color, 0.4),
// //       },
// //       '&::before': {
// //         content: '""',
// //         position: 'absolute',
// //         left: 0,
// //         top: '15%',
// //         bottom: '15%',
// //         width: '5px',
// //         borderRadius: '0 4px 4px 0',
// //         backgroundColor: color
// //       }
// //     }}
// //   >
// //     <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
// //       <Box sx={{ flex: 1 }}>
// //         <Typography sx={{ color: '#64748b', fontSize: '1rem', fontWeight: 600, mb: 1 }}>
// //           {title}
// //         </Typography>
// //         <Typography sx={{ fontSize: '2.2rem', fontWeight: 800, color: '#1e293b', letterSpacing: '-1px', lineHeight: 1 }}>
// //           {value}
// //         </Typography>
        
// //         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 2 }}>
// //           <Box sx={{ 
// //             display: 'flex', 
// //             alignItems: 'center', 
// //             bgcolor: trend === 'up' ? alpha('#10b981', 0.1) : alpha('#ef4444', 0.1),
// //             px: 1.2, py: 0.5, borderRadius: '8px' 
// //           }}>
// //             {trend === 'up' ? <TrendingUp size={16} color="#10b981" /> : <TrendingDown size={16} color="#ef4444" />}
// //             <Typography sx={{ ml: 0.5, fontSize: '0.85rem', fontWeight: 700, color: trend === 'up' ? '#059669' : '#dc2626' }}>
// //               {trendValue}
// //             </Typography>
// //           </Box>
// //           <Typography sx={{ fontSize: '0.85rem', color: '#94a3b8', fontWeight: 500 }}>today</Typography>
// //         </Box>
// //       </Box>

// //       <Box sx={{ 
// //         backgroundColor: alpha(color, 0.1), 
// //         p: 2, borderRadius: '18px', color: color,
// //         display: 'flex', alignItems: 'center', justifyContent: 'center'
// //       }}>
// //         <Icon size={32} strokeWidth={2.5} />
// //       </Box>
// //     </Box>
// //   </Paper>
// // );

// // const lineData = [
// //   { name: 'Jan', views: 4000 }, { name: 'Feb', views: 3500 }, { name: 'Mar', views: 5200 },
// //   { name: 'Apr', views: 4800 }, { name: 'May', views: 7000 }, { name: 'Jun', views: 8500 },
// //   { name: 'Jul', views: 9200 }, { name: 'Aug', views: 7800 }, { name: 'Sep', views: 8600 },
// //   { name: 'Oct', views: 9900 }, { name: 'Nov', views: 10400 }, { name: 'Dec', views: 12000 },
// // ];

// // const AdminDashboard = () => {
// //   const navigate = useNavigate();
// //   const [stats, setStats] = useState(null);
// //   const [loading, setLoading] = useState(true);

// //   // Data fetch karne ke liye useEffect
// //   useEffect(() => {
// //     const fetchStats = async () => {
// //       try {
// //         const response = await getDashboardStats();
// //         if (response.success) {
// //           setStats(response.data.summary);
// //         }
// //       } catch (error) {
// //         console.error("Error loading dashboard stats:", error);
// //       } finally {
// //         setLoading(false);
// //       }
// //     };
// //     fetchStats();
// //   }, []);

// //   if (loading) {
// //     return (
// //       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
// //         <CircularProgress size={60} thickness={4} sx={{ color: '#6366f1' }} />
// //       </Box>
// //     );
// //   }

// //   return (
// //     <Box sx={{ width: '100%', bgcolor: '#f8fafc', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
// //       <Box sx={{ p: { xs: 2, md: 4 }, width: '100%', boxSizing: 'border-box' }}>
        
// //         {/* Header Section */}
// //         <Box sx={{ mb: 5 }}>
// //           <Typography variant="h4" sx={{ fontWeight: 800, color: '#0f172a', letterSpacing: '-1.5px', fontSize: '2.25rem' }}>
// //             Dashboard
// //           </Typography>
// //           <Typography sx={{ color: '#64748b', fontSize: '1.1rem', mt: 1, fontWeight: 500 }}>
// //             Welcome back. Here's what's happening with your platform today.
// //           </Typography>
// //         </Box>

// //         {/* Stats Grid */}
// //         <Grid container spacing={4} sx={{ width: '100%', margin: 0 }}>
// //           <Grid item xs={12} sm={6} lg={4}>
// //             <StatCard 
// //               title="Total News" 
// //               value={stats?.news?.total || 0} 
// //               trend="up" 
// //               trendValue={`+${stats?.news?.today || 0}`} 
// //               icon={Newspaper} 
// //               color="#6366f1" 
// //               onClick={() => navigate('/AllNewsManagement')} // Path change kar lena
// //             />
// //           </Grid>
// //           <Grid item xs={12} sm={6} lg={4}>
// //             <StatCard 
// //               title="Pending Approvals" 
// //               value={stats?.news?.pending || 0} 
// //               trend="down" 
// //               trendValue="Action Req" 
// //               icon={Heading} 
// //               color="#8b5cf6" 
// //               onClick={() => navigate('/AllNewsManagement')}
// //             />
// //           </Grid>
// //           <Grid item xs={12} sm={6} lg={4}>
// //             <StatCard 
// //               title="Total Shorts" 
// //               value={stats?.shorts?.total || 0} 
// //               trend="up" 
// //               trendValue="Live" 
// //               icon={PlaySquare} 
// //               color="#0ea5e9" 
// //               onClick={() => navigate('/MyShortsList')}
// //             />
// //           </Grid>
// //           <Grid item xs={12} sm={6} lg={4}>
// //             <StatCard 
// //               title="Total Users" 
// //               value={stats?.users?.totalUsers || 0} 
// //               trend="up" 
// //               trendValue={`${stats?.users?.reporters || 0} Reporters`} 
// //               icon={Users} 
// //               color="#10b981" 
// //               onClick={() => navigate('#')}
// //             />
// //           </Grid>
// //           <Grid item xs={12} sm={6} lg={4}>
// //             <StatCard 
// //               title="Approved Companies" 
// //               value={stats?.business?.approvedCompanies || 0} 
// //               trend="down" 
// //               trendValue={`${stats?.business?.pendingApprovals || 0} Pending`} 
// //               icon={Building2} 
// //               color="#f59e0b" 
// //               onClick={() => navigate('/CompanyCategory')}
// //             />
// //           </Grid>
// //           <Grid item xs={12} sm={6} lg={4}>
// //             <StatCard 
// //               title="Total Polls" 
// //               value={stats?.engagement?.polls || 0} 
// //               trend="up" 
// //               trendValue="Active" 
// //               icon={BarChart3} 
// //               color="#4f46e5" 
// //               onClick={() => navigate('/PollList')}
// //             />
// //           </Grid>
// //         </Grid>

// //         {/* Chart Section */}
// //         <Box sx={{ mt: 6, width: '100%' }}>
// //           <Paper elevation={0} sx={{ p: { xs: 3, md: 5 }, borderRadius: '28px', border: '1px solid #e2e8f0', background: '#ffffff' }}>
// //             <Box sx={{ mb: 4 }}>
// //               <Typography sx={{ fontSize: '1.4rem', fontWeight: 700, color: '#0f172a', mb: 1 }}>
// //                 Views Analytics
// //               </Typography>
// //               <Typography sx={{ fontSize: '0.95rem', color: '#64748b' }}>
// //                 Total News Views: <b>{stats?.news?.totalViews?.toLocaleString() || 0}</b>
// //               </Typography>
// //             </Box>

// //             <Box sx={{ width: '100%', height: 400 }}>
// //               <ResponsiveContainer width="100%" height="100%">
// //                 <AreaChart data={lineData}>
// //                   <defs>
// //                     <linearGradient id="colorViews" x1="0" y1="0" x2="0" y2="1">
// //                       <stop offset="5%" stopColor="#6366f1" stopOpacity={0.4} />
// //                       <stop offset="95%" stopColor="#6366f1" stopOpacity={0} />
// //                     </linearGradient>
// //                   </defs>
// //                   <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
// //                   <XAxis dataKey="name" stroke="#94a3b8" />
// //                   <YAxis stroke="#94a3b8" />
// //                   <Tooltip />
// //                   <Area type="monotone" dataKey="views" stroke="#6366f1" strokeWidth={3} fill="url(#colorViews)" />
// //                 </AreaChart>
// //               </ResponsiveContainer>
// //             </Box>
// //           </Paper>
// //         </Box>
// //       </Box>
// //     </Box>
// //   );
// // };

// // export default AdminDashboard;






// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   Box,
//   Grid,
//   Paper,
//   Typography,
//   alpha,
//   CircularProgress
// } from "@mui/material";

// import {
//   Newspaper,
//   PlaySquare,
//   TrendingUp,
//   TrendingDown,
//   Users,
//   Building2,
//   BarChart3,
//   Heading
// } from "lucide-react";

// import {
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
//   AreaChart,
//   Area
// } from "recharts";

// import { getDashboardStats } from "../../../services/adminService";

// /* =============================
//    Stat Card
// ============================= */

// const StatCard = ({
//   title,
//   value,
//   trend,
//   trendValue,
//   icon: Icon,
//   color,
//   onClick
// }) => (
//   <Paper
//     elevation={0}
//     onClick={onClick}
//     sx={{
//       p: 4,
//       height: "100%",
//       borderRadius: "24px",
//       border: "1px solid",
//       borderColor: alpha("#e2e8f0", 0.8),
//       background: "#ffffff",
//       position: "relative",
//       overflow: "hidden",
//       cursor: "pointer",
//       display: "flex",
//       flexDirection: "column",
//       justifyContent: "center",
//       transition: "all 0.3s ease",

//       "&:hover": {
//         transform: "translateY(-5px)",
//         boxShadow: "0 20px 25px -5px rgba(0,0,0,0.05)",
//         borderColor: alpha(color, 0.4)
//       },

//       "&::before": {
//         content: '""',
//         position: "absolute",
//         left: 0,
//         top: "15%",
//         bottom: "15%",
//         width: "5px",
//         borderRadius: "0 4px 4px 0",
//         backgroundColor: color
//       }
//     }}
//   >
//     <Box
//       sx={{
//         display: "flex",
//         justifyContent: "space-between",
//         alignItems: "center"
//       }}
//     >
//       <Box sx={{ flex: 1 }}>
//         <Typography
//           sx={{ color: "#64748b", fontSize: "1rem", fontWeight: 600, mb: 1 }}
//         >
//           {title}
//         </Typography>

//         <Typography
//           sx={{
//             fontSize: "2.2rem",
//             fontWeight: 800,
//             color: "#1e293b",
//             letterSpacing: "-1px",
//             lineHeight: 1
//           }}
//         >
//           {value}
//         </Typography>

//         <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 2 }}>
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               bgcolor:
//                 trend === "up"
//                   ? alpha("#10b981", 0.1)
//                   : alpha("#ef4444", 0.1),
//               px: 1.2,
//               py: 0.5,
//               borderRadius: "8px"
//             }}
//           >
//             {trend === "up" ? (
//               <TrendingUp size={16} color="#10b981" />
//             ) : (
//               <TrendingDown size={16} color="#ef4444" />
//             )}

//             <Typography
//               sx={{
//                 ml: 0.5,
//                 fontSize: "0.85rem",
//                 fontWeight: 700,
//                 color: trend === "up" ? "#059669" : "#dc2626"
//               }}
//             >
//               {trendValue}
//             </Typography>
//           </Box>

//           <Typography
//             sx={{ fontSize: "0.85rem", color: "#94a3b8", fontWeight: 500 }}
//           >
//             today
//           </Typography>
//         </Box>
//       </Box>

//       <Box
//         sx={{
//           backgroundColor: alpha(color, 0.1),
//           p: 2,
//           borderRadius: "18px",
//           color: color,
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center"
//         }}
//       >
//         <Icon size={32} strokeWidth={2.5} />
//       </Box>
//     </Box>
//   </Paper>
// );

// /* =============================
//    Chart Data
// ============================= */

// const lineData = [
//   { name: "Jan", views: 4000 },
//   { name: "Feb", views: 3500 },
//   { name: "Mar", views: 5200 },
//   { name: "Apr", views: 4800 },
//   { name: "May", views: 7000 },
//   { name: "Jun", views: 8500 },
//   { name: "Jul", views: 9200 },
//   { name: "Aug", views: 7800 },
//   { name: "Sep", views: 8600 },
//   { name: "Oct", views: 9900 },
//   { name: "Nov", views: 10400 },
//   { name: "Dec", views: 12000 }
// ];

// /* =============================
//    Dashboard
// ============================= */

// const AdminDashboard = () => {
//   const navigate = useNavigate();

//   const [stats, setStats] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchStats = async () => {
//       try {
//         const res = await getDashboardStats();

//         if (res?.success) {
//           setStats(res.data.summary);
//         }
//       } catch (error) {
//         console.error("Dashboard error:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchStats();
//   }, []);

//   if (loading) {
//     return (
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "80vh"
//         }}
//       >
//         <CircularProgress size={60} thickness={4} sx={{ color: "#6366f1" }} />
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ width: "100%", bgcolor: "#f8fafc", minHeight: "100vh" }}>
//       <Box sx={{ p: { xs: 2, md: 4 } }}>
        
//         {/* Header */}

//         <Box sx={{ mb: 5 }}>
//           <Typography
//             variant="h4"
//             sx={{ fontWeight: 800, color: "#0f172a" }}
//           >
//             Dashboard
//           </Typography>

//           <Typography
//             sx={{
//               color: "#64748b",
//               fontSize: "1.1rem",
//               mt: 1,
//               fontWeight: 500
//             }}
//           >
//             Welcome back. Here's what's happening with your platform today.
//           </Typography>
//         </Box>

//         {/* Stats */}

//         <Grid container spacing={4}>
          
//           <Grid item xs={12} sm={6} lg={4}>
//             <StatCard
//               title="Total News"
//               value={stats?.news?.total || 0}
//               trend="up"
//               trendValue={`+${stats?.news?.today || 0}`}
//               icon={Newspaper}
//               color="#6366f1"
//               onClick={() => navigate("/AllNewsManagement")}
//             />
//           </Grid>

//           <Grid item xs={12} sm={6} lg={4}>
//             <StatCard
//               title="Pending Approvals"
//               value={stats?.news?.pending || 0}
//               trend="down"
//               trendValue="Action Req"
//               icon={Heading}
//               color="#8b5cf6"
//               onClick={() => navigate("/AllNewsManagement")}
//             />
//           </Grid>

//           <Grid item xs={12} sm={6} lg={4}>
//             <StatCard
//               title="Total Shorts"
//               value={stats?.shorts?.total || 0}
//               trend="up"
//               trendValue="Live"
//               icon={PlaySquare}
//               color="#0ea5e9"
//               onClick={() => navigate("/MyShortsList")}
//             />
//           </Grid>

//           <Grid item xs={12} sm={6} lg={4}>
//             <StatCard
//               title="Total Users"
//               value={stats?.users?.totalUsers || 0}
//               trend="up"
//               trendValue={`${stats?.users?.reporters || 0} Reporters`}
//               icon={Users}
//               color="#10b981"
//             />
//           </Grid>

//           <Grid item xs={12} sm={6} lg={4}>
//             <StatCard
//               title="Approved Companies"
//               value={stats?.business?.approvedCompanies || 0}
//               trend="down"
//               trendValue={`${stats?.business?.pendingApprovals || 0} Pending`}
//               icon={Building2}
//               color="#f59e0b"
//               onClick={() => navigate("/CompanyCategory")}
//             />
//           </Grid>

//           <Grid item xs={12} sm={6} lg={4}>
//             <StatCard
//               title="Total Polls"
//               value={stats?.engagement?.polls || 0}
//               trend="up"
//               trendValue="Active"
//               icon={BarChart3}
//               color="#4f46e5"
//               onClick={() => navigate("/PollList")}
//             />
//           </Grid>

//         </Grid>

//         {/* Chart */}

//         <Box sx={{ mt: 6 }}>
//           <Paper
//             elevation={0}
//             sx={{
//               p: { xs: 3, md: 5 },
//               borderRadius: "28px",
//               border: "1px solid #e2e8f0"
//             }}
//           >
//             <Typography
//               sx={{
//                 fontSize: "1.4rem",
//                 fontWeight: 700,
//                 color: "#0f172a",
//                 mb: 1
//               }}
//             >
//               Views Analytics
//             </Typography>

//             <Typography sx={{ fontSize: "0.95rem", color: "#64748b", mb: 3 }}>
//               Total News Views:{" "}
//               <b>{stats?.news?.totalViews?.toLocaleString() || 0}</b>
//             </Typography>

//             <Box sx={{ width: "100%", height: 400 }}>
//               <ResponsiveContainer width="100%" height="100%">
//                 <AreaChart data={lineData}>
//                   <defs>
//                     <linearGradient id="colorViews" x1="0" y1="0" x2="0" y2="1">
//                       <stop offset="5%" stopColor="#6366f1" stopOpacity={0.4} />
//                       <stop offset="95%" stopColor="#6366f1" stopOpacity={0} />
//                     </linearGradient>
//                   </defs>

//                   <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
//                   <XAxis dataKey="name" stroke="#94a3b8" />
//                   <YAxis stroke="#94a3b8" />
//                   <Tooltip />

//                   <Area
//                     type="monotone"
//                     dataKey="views"
//                     stroke="#6366f1"
//                     strokeWidth={3}
//                     fill="url(#colorViews)"
//                   />
//                 </AreaChart>
//               </ResponsiveContainer>
//             </Box>
//           </Paper>
//         </Box>

//       </Box>
//     </Box>
//   );
// };

// export default AdminDashboard;


import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import {
  ResponsiveContainer, AreaChart, Area, XAxis, YAxis,
  CartesianGrid, Tooltip
} from 'recharts';
import { getDashboardStats } from '../../../services/adminService';

// ─── Color map per card ───────────────────────────────────────────────────────
const CARD_COLORS = {
  indigo:  { glow: '#818cf8', badge: 'rgba(129,140,248,0.15)', text: '#818cf8' },
  purple:  { glow: '#a78bfa', badge: 'rgba(167,139,250,0.15)', text: '#a78bfa' },
  sky:     { glow: '#38bdf8', badge: 'rgba(56,189,248,0.15)',  text: '#38bdf8' },
  emerald: { glow: '#34d399', badge: 'rgba(52,211,153,0.15)',  text: '#34d399' },
  amber:   { glow: '#fbbf24', badge: 'rgba(251,191,36,0.15)',  text: '#fbbf24' },
  violet:  { glow: '#7c3aed', badge: 'rgba(124,58,237,0.15)',  text: '#7c3aed' },
};

// ─── Icons ────────────────────────────────────────────────────────────────────
const NewsIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" width="18" height="18">
    <path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2"/>
    <path d="M18 14h-8M15 18h-5M10 6h8v4h-8z"/>
  </svg>
);
const EditIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" width="18" height="18">
    <path d="M12 20h9"/>
    <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/>
  </svg>
);
const ShortsIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" width="18" height="18">
    <rect x="2" y="2" width="20" height="20" rx="2.18"/>
    <path d="M7 2v20M17 2v20M2 12h20M2 7h5M2 17h5M17 17h5M17 7h5"/>
  </svg>
);
const UsersIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" width="18" height="18">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);
const BuildingIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" width="18" height="18">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
    <polyline points="9 22 9 12 15 12 15 22"/>
  </svg>
);
const PollIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" width="18" height="18">
    <line x1="18" y1="20" x2="18" y2="10"/>
    <line x1="12" y1="20" x2="12" y2="4"/>
    <line x1="6" y1="20" x2="6" y2="14"/>
  </svg>
);
const TrendUpIcon = () => (
  <svg viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.5"
    width="10" height="10">
    <path d="M2 7L5 3l3 4"/>
  </svg>
);
const TrendDownIcon = () => (
  <svg viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.5"
    width="10" height="10">
    <path d="M2 3L5 7l3-4"/>
  </svg>
);
const WarnIcon = () => (
  <svg viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.5"
    width="10" height="10">
    <path d="M5 2v4M5 8v.5"/>
  </svg>
);

// ─── Stat Card ────────────────────────────────────────────────────────────────
const StatCard = ({ label, value, badgeType, badgeText, subText, icon: Icon, colorKey, onClick }) => {
  const c = CARD_COLORS[colorKey];
  const badgeBg = badgeType === 'up'
    ? 'rgba(52,211,153,0.12)' : badgeType === 'down'
    ? 'rgba(251,191,36,0.12)' : 'rgba(248,113,113,0.12)';
  const badgeColor = badgeType === 'up' ? '#34d399' : badgeType === 'down' ? '#fbbf24' : '#f87171';
  const BadgeIcon = badgeType === 'up' ? TrendUpIcon : badgeType === 'down' ? TrendDownIcon : WarnIcon;

  return (
    <Box
      onClick={onClick}
      sx={{
        // background: '#13172b',
        border: '1px solid rgba(255,255,255,0.06)',
        borderRadius: '18px',
        p: '20px 22px',
        cursor: 'pointer',
        position: 'relative',
        overflow: 'hidden',
        transition: 'transform 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease',
        '&:hover': {
          transform: 'translateY(-4px)',
          borderColor: 'rgba(255,255,255,0.12)',
          boxShadow: '0 20px 40px rgba(0,0,0,0.35)',
        },
        '&::before': {
          content: '""',
          position: 'absolute',
          width: '120px', height: '120px',
          borderRadius: '50%',
          top: '-30px', right: '-30px',
          background: c.glow,
          opacity: 0.12,
          filter: 'blur(40px)',
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          left: 0, top: '20%', bottom: '20%',
          width: '3px',
          borderRadius: '0 3px 3px 0',
          background: c.glow,
        },
      }}
    >
      {/* Top row */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: '14px' }}>
        <Box sx={{ fontSize: '11.5px', fontWeight: 600, color: '#6b7298', letterSpacing: '0.5px', textTransform: 'uppercase' }}>
          {label}
        </Box>
        <Box sx={{
          width: '36px', height: '36px', borderRadius: '10px',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: c.badge, color: c.text,
        }}>
          <Icon />
        </Box>
      </Box>

      {/* Value */}
      <Box sx={{ fontSize: '30px', fontWeight: 700, letterSpacing: '-1.5px', color: '#2638c0', lineHeight: 1, mb: '12px', fontFamily: '"DM Mono", monospace' }}>
        {value}
      </Box>

      {/* Footer */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Box sx={{
          display: 'flex', alignItems: 'center', gap: '4px',
          px: '9px', py: '3px', borderRadius: '20px',
          background: badgeBg, color: badgeColor,
          fontSize: '11px', fontWeight: 600,
        }}>
          <BadgeIcon />
          {badgeText}
        </Box>
        <Box sx={{ fontSize: '11.5px', color: '#4a506a', fontWeight: 500 }}>{subText}</Box>
      </Box>
    </Box>
  );
};

// ─── Chart data ───────────────────────────────────────────────────────────────
const lineData = [
  { name: 'Jan', views: 4000 }, { name: 'Feb', views: 3500 }, { name: 'Mar', views: 5200 },
  { name: 'Apr', views: 4800 }, { name: 'May', views: 7000 }, { name: 'Jun', views: 8500 },
  { name: 'Jul', views: 9200 }, { name: 'Aug', views: 7800 }, { name: 'Sep', views: 8600 },
  { name: 'Oct', views: 9900 }, { name: 'Nov', views: 10400 }, { name: 'Dec', views: 12000 },
];

// ─── Custom Tooltip ───────────────────────────────────────────────────────────
const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <Box sx={{
      background: '#1a1f38', border: '1px solid rgba(129,140,248,0.3)',
      borderRadius: '10px', px: 2, py: 1.5,
    }}>
      <Box sx={{ fontSize: '11px', color: '#6b7298', mb: '2px' }}>{label}</Box>
      <Box sx={{ fontSize: '16px', fontWeight: 700, color: '#818cf8', fontFamily: '"DM Mono", monospace' }}>
        {payload[0].value.toLocaleString()}
      </Box>
    </Box>
  );
};

// ─── Main Dashboard ───────────────────────────────────────────────────────────
const AdminDashboard = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await getDashboardStats();
        if (response.success) setStats(response.data.summary);
      } catch (error) {
        console.error('Error loading dashboard stats:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh',  }}>
        <CircularProgress size={52} thickness={4} sx={{ color: '#818cf8' }} />
      </Box>
    );
  }

  return (
    <Box sx={{
    //   background: '#0d0f1a',
      minHeight: '100vh',
      p: { xs: '20px 16px', md: '28px 28px' },
      fontFamily: '"DM Sans", sans-serif',
      color: '#e2e4f0',
    }}>

      {/* ── Header ── */}
      <Box sx={{ mb: 4 }}>
        <Box sx={{
          fontSize: '26px', fontWeight: 700, letterSpacing: '-0.8px',
          background: 'linear-gradient(135deg, #2a59db 0%, #0f33e7 100%)',
          WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
        }}>
          Admin Dashboard
        </Box>
        <Box sx={{ fontSize: '13px', color: '#6b7298', mt: '4px' }}>
          Welcome back. Here's what's happening on your platform today.
        </Box>
      </Box>

      {/* ── Stats Grid ── */}
      <Box sx={{
         background: '#f2f2f3',
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' },
        gap: '16px',
        mb: '28px',
      }}>
        <StatCard
          label="Total News"
          value={stats?.news?.total?.toLocaleString() || '0'}
          badgeType="up"
          badgeText={`+${stats?.news?.today || 0} today`}
          subText="articles live"
      
          icon={NewsIcon}
          colorKey="indigo"
          onClick={() => navigate('/AllNewsManagement')}
        />
        <StatCard
          label="Pending Approvals"
          value={stats?.news?.pending || '0'}
          badgeType="warn"
          badgeText="Action Req"
          subText="needs review"
          icon={EditIcon}
          colorKey="purple"
          onClick={() => navigate('/AllNewsManagement')}
        />
        <StatCard
          label="Total Shorts"
          value={stats?.shorts?.total?.toLocaleString() || '0'}
          badgeType="up"
          badgeText="Live"
          subText="video clips"
          icon={ShortsIcon}
          colorKey="sky"
          onClick={() => navigate('/MyShortsList')}
        />
        <StatCard
          label="Total Users"
          value={stats?.users?.totalUsers?.toLocaleString() || '0'}
          badgeType="up"
          badgeText={`${stats?.users?.reporters || 0} Reporters`}
          subText="registered"
          icon={UsersIcon}
          colorKey="emerald"
          onClick={() => navigate('#')}
        />
        <StatCard
          label="Approved Companies"
          value={stats?.business?.approvedCompanies?.toLocaleString() || '0'}
          badgeType="down"
          badgeText={`${stats?.business?.pendingApprovals || 0} Pending`}
          subText="businesses"
          icon={BuildingIcon}
          colorKey="amber"
          onClick={() => navigate('/CompanyCategory')}
        />
        <StatCard
          label="Total Polls"
          value={stats?.engagement?.polls?.toLocaleString() || '0'}
          badgeType="up"
          badgeText="Active"
          subText="polls running"
          icon={PollIcon}
          colorKey="violet"
          onClick={() => navigate('/PollList')}
        />
      </Box>

      {/* ── Chart Panel ── */}
      <Box sx={{
        // background: '#13172b',
        border: '1px solid rgba(255,255,255,0.06)',
        borderRadius: '20px',
        p: { xs: '20px 18px', md: '24px 28px' },
      }}>
        {/* Chart header */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3 }}>
          <Box>
            <Box sx={{ fontSize: '15px', fontWeight: 600, color: '#d4d7f0', letterSpacing: '-0.3px' }}>
              Views Analytics
            </Box>
            <Box sx={{ fontSize: '12px', color: '#4a506a', mt: '3px' }}>
              Monthly news views — current year
            </Box>
          </Box>
          <Box sx={{ textAlign: 'right' }}>
            <Box sx={{ fontSize: '22px', fontWeight: 700, color: '#818cf8', fontFamily: '"DM Mono", monospace' }}>
              {stats?.news?.totalViews?.toLocaleString() || '87.4K'}
            </Box>
            <Box sx={{ fontSize: '11px', color: '#4a506a', mt: '2px' }}>total views this year</Box>
          </Box>
        </Box>

        {/* Recharts AreaChart */}
        <Box sx={{ height: 260 }}>
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={lineData} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
              <defs>
                <linearGradient id="colorViews" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%"  stopColor="#818cf8" stopOpacity={0.35} />
                  <stop offset="95%" stopColor="#818cf8" stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" stroke="#1e2240" vertical={false} />
              <XAxis
                dataKey="name"
                stroke="transparent"
                tick={{ fill: '#383d5a', fontSize: 11, fontFamily: '"DM Sans", sans-serif' }}
                axisLine={false} tickLine={false}
              />
              <YAxis
                stroke="transparent"
                tick={{ fill: '#383d5a', fontSize: 10, fontFamily: '"DM Mono", monospace' }}
                axisLine={false} tickLine={false}
                tickFormatter={v => `${(v / 1000).toFixed(0)}K`}
              />
              <Tooltip content={<CustomTooltip />} cursor={{ stroke: '#818cf8', strokeWidth: 1, strokeDasharray: '4 4' }} />
              <Area
                type="monotone"
                dataKey="views"
                stroke="#818cf8"
                strokeWidth={2.5}
                fill="url(#colorViews)"
                dot={false}
                activeDot={{ r: 5, fill: '#818cf8', stroke: '#0d0f1a', strokeWidth: 2 }}
              />
            </AreaChart>
          </ResponsiveContainer>
        </Box>
      </Box>

    </Box>
  );
};

export default AdminDashboard;
